jQuery(function ($) {
  // Center scrollable nav for small screens
  const activeTab = $('.patient-journey__nav-item a.active').parent();
  if (activeTab.length) {
    const nav = $('.patient-journey__nav');
    const myScrollPos =
      activeTab.offset().left + activeTab.outerWidth(true) / 2 + nav.scrollLeft() - nav.width() / 2;
    $('.patient-journey__nav').scrollLeft(myScrollPos);
  }
});
